document.querySelectorAll(".round-btn-wrapper").forEach(wrapper => {
  const buttons = wrapper.querySelectorAll(".round-btn");

  const parent = wrapper.parentElement;
  const firstTable = parent.querySelector(".standings-table-wrapper.first-round");
  const secondTable = parent.querySelector(".standings-table-wrapper.second-round");

  if (!firstTable || !secondTable || buttons.length < 2) return;

  buttons[0].addEventListener("click", () => {
    buttons[0].classList.add("active");
    buttons[1].classList.remove("active");

    firstTable.classList.add("active");
    secondTable.classList.remove("active");
  });

  buttons[1].addEventListener("click", () => {
    buttons[1].classList.add("active");
    buttons[0].classList.remove("active");

    secondTable.classList.add("active");
    firstTable.classList.remove("active");
  });
});